// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import "./Ecommerce.css";

// const Productbydetail = () => {
//   const { id } = useParams();
//   const [product, setProduct] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [mainImage, setMainImage] = useState("");
//   const [activeIndex, setActiveIndex] = useState(0);

//   useEffect(() => {
//     const fetchProduct = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(
//           `https://vogelkoparchitects.com/api/ecom/products/${id}/`,
//         );

//         if (!response.ok) {
//           throw new Error("Failed to fetch product");
//         }

//         const productData = await response.json();
//         setProduct(productData);

//         // Set initial main image
//         if (productData.main_image) {
//           setMainImage(productData.main_image);
//         }

//         setLoading(false);
//       } catch (err) {
//         console.error("Error fetching product:", err);
//         setError("Failed to load product. Please try again later.");
//         setLoading(false);
//       }
//     };

//     fetchProduct();
//   }, [id]);

//   // Get all product images from the image array
//   const getProductImages = () => {
//     if (!product || !product.image) return [];

//     // Extract all images from the image array
//     return product.image.map((img) => img.image);
//   };

//   // Function to handle image click
//   const handleImageClick = (imageSrc, index) => {
//     setMainImage(imageSrc);
//     setActiveIndex(index);
//   };

//   // Group prices by category and include all wood types
//   const groupPricesByCategory = () => {
//     if (!product || !product.price) return {};

//     const grouped = {};

//     product.price.forEach((priceItem) => {
//       const category = priceItem.category;

//       if (!grouped[category]) {
//         grouped[category] = {
//           sizes: new Set(),
//           woodTypes: {},
//         };
//       }

//       // Add size to the set
//       grouped[category].sizes.add(priceItem.size);

//       // Initialize wood type if not exists
//       if (!grouped[category].woodTypes[priceItem.wood_type]) {
//         grouped[category].woodTypes[priceItem.wood_type] = {};
//       }

//       // Add price for this size and wood type
//       grouped[category].woodTypes[priceItem.wood_type][priceItem.size] = {
//         price: priceItem.price,
//         price_incl_tax: priceItem.price_incl_tax,
//       };
//     });

//     // Convert sets to arrays and sort sizes
//     Object.keys(grouped).forEach((category) => {
//       grouped[category].sizes = Array.from(grouped[category].sizes).sort();
//     });

//     return grouped;
//   };

//   // Filter visible specifications
//   const getVisibleSpecifications = () => {
//     if (!product || !product.specifications) return [];
//     return product.specifications.filter((spec) => spec.is_visible === true);
//   };

//   // Format currency
//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat("en-IN", {
//       style: "currency",
//       currency: "INR",
//       maximumFractionDigits: 0,
//     }).format(amount);
//   };

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner"></div>
//         <p>Loading product details...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="error-container">
//         <p>{error}</p>
//       </div>
//     );
//   }

//   if (!product) {
//     return (
//       <div className="empty-state">
//         <h2>Product not found</h2>
//         <p>The requested product could not be found.</p>
//       </div>
//     );
//   }

//   const productImages = getProductImages();
//   const groupedPrices = groupPricesByCategory();
//   const visibleSpecifications = getVisibleSpecifications();

//   return (
//     <>
//       <div className="product-detail-banner">
//         <img
//           src={mainImage || product.main_image}
//           alt="Product banner"
//           className="product-detail-banner-image"
//           onError={(e) => {
//             e.target.src = "/path/to/placeholder-image.jpg";
//           }}
//         />
//         <h1 className="product-detail-title">Product Detail</h1>
//       </div>

//       <div className="product-detail-container">
//         {/* Main Product Image */}
//         <div className="detailproduct-header">
//           <img
//             src={mainImage || product.main_image}
//             alt={product.product_name}
//             onError={(e) => {
//               e.target.src = "/path/to/placeholder-image.jpg";
//             }}
//           />
//         </div>

//         {/* Thumbnail Images - Now using the image array */}
//         {productImages.length > 1 && (
//           <div className="productdetail-productcrousel">
//             {productImages.map((image, index) => (
//               <img
//                 key={index}
//                 src={image}
//                 alt={`${product.product_name} view ${index + 1}`}
//                 onClick={() => handleImageClick(image, index)}
//                 className={mainImage === image ? "active" : ""}
//                 onError={(e) => {
//                   e.target.src = "/path/to/placeholder-image.jpg";
//                 }}
//               />
//             ))}
//           </div>
//         )}

//         {/* Product Info */}
//         <div>
//           <h1 className="product-code">{product.group_code}</h1>
//           <h2 className="product-type">{product.product_name}</h2>
//           <p className="product-description">
//             {product.description || product.hint}
//           </p>
//         </div>

//         {/* Price Tables */}
//         {product.price && product.price.length > 0 && (
//           <div className="price-list-section">
//             <h1 className="price-list-title">SIZE & PRICE LIST</h1>

//             {Object.entries(groupedPrices).map(([category, data]) => (
//               <div key={category} className="price-table-container">
//                 <h2 className="table-subtitle">{category}</h2>
//                 <table className="price-table">
//                   <thead>
//                     <tr>
//                       <th>Wood Type / Size</th>
//                       {data.sizes.map((size) => (
//                         <th key={size}>{size}</th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {Object.entries(data.woodTypes).map(
//                       ([woodType, prices]) => (
//                         <tr key={woodType}>
//                           <td>{woodType}</td>
//                           {data.sizes.map((size) => (
//                             <td key={size}>
//                               {prices[size] ? (
//                                 <>
//                                   {formatCurrency(prices[size].price)}
//                                   <br />
//                                   <span className="gst-text">
//                                     (incl. GST{" "}
//                                     {formatCurrency(
//                                       prices[size].price_incl_tax,
//                                     )}
//                                     )
//                                   </span>
//                                 </>
//                               ) : (
//                                 "-"
//                               )}
//                             </td>
//                           ))}
//                         </tr>
//                       ),
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             ))}

//             <div className="product-notes">
//               <p>※Bank and height are standard at D780×H770mm.</p>
//               <p>
//                 ※Height can be ordered between SH370～470mm (in 10mm
//                 increments).
//               </p>
//               <p>
//                 ※In addition to denim and desk work, we also offer various
//                 textures of various recommendations. Please check briefly.
//               </p>
//             </div>
//           </div>
//         )}

//         {/* Specifications - Only visible ones */}
//         {visibleSpecifications.length > 0 && (
//           <div className="specifications-section">
//             {visibleSpecifications.map((spec, index) => {
//               // Get specification images (max 3)
//               const specImages = spec.specificationsimages?.slice(0, 3) || [];

//               return (
//                 <div key={spec.id || index} className="product-feature-section">
//                   <h2 className="feature-section-title">{spec.key}</h2>

//                   {/* Images section */}
//                   {specImages.length > 0 && (
//                     <div
//                       className={`spec-images-container spec-images-${specImages.length}`}
//                     >
//                       {specImages.map((img, imgIndex) => (
//                         <img
//                           key={img.id || imgIndex}
//                           src={img.image}
//                           alt={`${spec.key} ${imgIndex + 1}`}
//                           className="spec-image"
//                           onError={(e) => {
//                             e.target.src = "/path/to/placeholder-image.jpg";
//                           }}
//                         />
//                       ))}
//                     </div>
//                   )}

//                   {/* Title and description */}
//                   {spec.title && (
//                     <p className="feature-section-description">{spec.title}</p>
//                   )}
//                   {spec.value && (
//                     <p className="feature-section-text">{spec.value}</p>
//                   )}
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default Productbydetail;

// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import "./Ecommerce.css";

// const Productbydetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [product, setProduct] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [mainImage, setMainImage] = useState("");
//   const [activeIndex, setActiveIndex] = useState(0);

//   // Cart state
//   const [selectedPrice, setSelectedPrice] = useState(null);
//   const [quantity, setQuantity] = useState(1);
//   const [addingToCart, setAddingToCart] = useState(false);
//   const [cartMessage, setCartMessage] = useState({ type: "", text: "" });
//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   useEffect(() => {
//     // Check if user is logged in by verifying access token
//     const token = localStorage.getItem("accessToken");
//     setIsLoggedIn(!!token);

//     const fetchProduct = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(
//           `https://vogelkoparchitects.com/api/ecom/products/${id}/`,
//         );

//         if (!response.ok) {
//           throw new Error("Failed to fetch product");
//         }

//         const productData = await response.json();
//         setProduct(productData);

//         // Set initial main image
//         if (productData.main_image) {
//           setMainImage(productData.main_image);
//         }

//         setLoading(false);
//       } catch (err) {
//         console.error("Error fetching product:", err);
//         setError("Failed to load product. Please try again later.");
//         setLoading(false);
//       }
//     };

//     fetchProduct();
//   }, [id]);

//   // Function to refresh token (you'll need to implement this based on your API)
//   const refreshToken = async () => {
//     try {
//       const refresh = localStorage.getItem("refreshToken");
//       if (!refresh) {
//         return null;
//       }

//       const response = await fetch(
//         "https://vogelkoparchitects.com/api/token/refresh/",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             refresh: refresh,
//           }),
//         },
//       );

//       if (response.ok) {
//         const data = await response.json();
//         localStorage.setItem("accessToken", data.access);
//         return data.access;
//       } else {
//         // If refresh fails, clear tokens and redirect to login
//         localStorage.removeItem("accessToken");
//         localStorage.removeItem("refreshToken");
//         setIsLoggedIn(false);
//         return null;
//       }
//     } catch (error) {
//       console.error("Error refreshing token:", error);
//       return null;
//     }
//   };

//   // Function to make authenticated API calls with token refresh
//   const makeAuthenticatedRequest = async (url, options = {}) => {
//     let token = localStorage.getItem("accessToken");

//     if (!token) {
//       return { error: "No token", status: 401 };
//     }

//     // First attempt with current token
//     let response = await fetch(url, {
//       ...options,
//       headers: {
//         ...options.headers,
//         Authorization: `Bearer ${token}`,
//       },
//     });

//     // If token is invalid, try to refresh
//     if (response.status === 401) {
//       const newToken = await refreshToken();

//       if (newToken) {
//         // Retry with new token
//         response = await fetch(url, {
//           ...options,
//           headers: {
//             ...options.headers,
//             Authorization: `Bearer ${newToken}`,
//           },
//         });
//       } else {
//         // Token refresh failed
//         navigate("/AuthForm");
//         return { error: "Session expired", status: 401 };
//       }
//     }

//     return response;
//   };

//   // Get all product images from the image array
//   const getProductImages = () => {
//     if (!product || !product.image) return [];
//     return product.image.map((img) => img.image);
//   };

//   // Function to handle image click
//   const handleImageClick = (imageSrc, index) => {
//     setMainImage(imageSrc);
//     setActiveIndex(index);
//   };

//   // Group prices by category and include all wood types
//   const groupPricesByCategory = () => {
//     if (!product || !product.price) return {};

//     const grouped = {};

//     product.price.forEach((priceItem) => {
//       const category = priceItem.category;

//       if (!grouped[category]) {
//         grouped[category] = {
//           sizes: new Set(),
//           woodTypes: {},
//         };
//       }

//       grouped[category].sizes.add(priceItem.size);

//       if (!grouped[category].woodTypes[priceItem.wood_type]) {
//         grouped[category].woodTypes[priceItem.wood_type] = {};
//       }

//       grouped[category].woodTypes[priceItem.wood_type][priceItem.size] = {
//         id: priceItem.id,
//         price: priceItem.price,
//         price_incl_tax: priceItem.price_incl_tax,
//       };
//     });

//     Object.keys(grouped).forEach((category) => {
//       grouped[category].sizes = Array.from(grouped[category].sizes).sort();
//     });

//     return grouped;
//   };

//   // Filter visible specifications
//   const getVisibleSpecifications = () => {
//     if (!product || !product.specifications) return [];
//     return product.specifications.filter((spec) => spec.is_visible === true);
//   };

//   // Format currency
//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat("en-IN", {
//       style: "currency",
//       currency: "INR",
//       maximumFractionDigits: 0,
//     }).format(amount);
//   };

//   // Handle price selection
//   const handlePriceSelect = (priceId) => {
//     setSelectedPrice(priceId);
//     setCartMessage({ type: "", text: "" }); // Clear any previous messages
//   };

//   // Handle quantity change
//   const handleQuantityChange = (e) => {
//     const value = parseInt(e.target.value);
//     if (value > 0) {
//       setQuantity(value);
//     }
//   };

//   // Add to cart function with token refresh handling
//   const addToCart = async () => {
//     // Check if user is logged in
//     const token = localStorage.getItem("accessToken");
//     if (!token) {
//       setCartMessage({
//         type: "error",
//         text: "Please log in to add items to cart",
//       });
//       setTimeout(() => {
//         navigate("/AuthForm");
//       }, 2000);
//       return;
//     }

//     // Check if a price is selected
//     if (!selectedPrice) {
//       setCartMessage({
//         type: "error",
//         text: "Please select a size and wood type combination",
//       });
//       return;
//     }

//     setAddingToCart(true);
//     setCartMessage({ type: "", text: "" });

//     try {
//       const response = await makeAuthenticatedRequest(
//         "https://vogelkoparchitects.com/api/ecom/cart/",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             product_id: parseInt(id),
//             quantity: quantity,
//             price_id: selectedPrice,
//           }),
//         },
//       );

//       // Check if response is an error object
//       if (response.error) {
//         if (response.status === 401) {
//           setCartMessage({
//             type: "error",
//             text: "Your session has expired. Please login again.",
//           });
//           setTimeout(() => {
//             navigate("/AuthForm");
//           }, 2000);
//         } else {
//           throw new Error(response.error);
//         }
//         return;
//       }

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || "Failed to add to cart");
//       }

//       // Success message
//       setCartMessage({
//         type: "success",
//         text: data.message || "Product added to cart successfully!",
//       });

//       // Clear selection after successful addition (optional)
//       setTimeout(() => {
//         setCartMessage({ type: "", text: "" });
//       }, 3000);
//     } catch (err) {
//       console.error("Error adding to cart:", err);
//       setCartMessage({
//         type: "error",
//         text: err.message || "Failed to add to cart. Please try again.",
//       });
//     } finally {
//       setAddingToCart(false);
//     }
//   };

//   // Get selected price details for display
//   const getSelectedPriceDetails = () => {
//     if (!selectedPrice || !product || !product.price) return null;
//     return product.price.find((p) => p.id === selectedPrice);
//   };

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner"></div>
//         <p>Loading product details...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="error-container">
//         <p>{error}</p>
//       </div>
//     );
//   }

//   if (!product) {
//     return (
//       <div className="empty-state">
//         <h2>Product not found</h2>
//         <p>The requested product could not be found.</p>
//       </div>
//     );
//   }

//   const productImages = getProductImages();
//   const groupedPrices = groupPricesByCategory();
//   const visibleSpecifications = getVisibleSpecifications();
//   const selectedPriceDetails = getSelectedPriceDetails();

//   return (
//     <>
//       <div className="product-detail-banner">
//         <img
//           src={mainImage || product.main_image}
//           alt="Product banner"
//           className="product-detail-banner-image"
//           onError={(e) => {
//             e.target.src = "/path/to/placeholder-image.jpg";
//           }}
//         />
//         <h1 className="product-detail-title">Product Detail</h1>
//       </div>

//       <div className="product-detail-container">
//         {/* Main Product Image */}
//         <div className="detailproduct-header">
//           <img
//             src={mainImage || product.main_image}
//             alt={product.product_name}
//             onError={(e) => {
//               e.target.src = "/path/to/placeholder-image.jpg";
//             }}
//           />
//         </div>

//         {/* Thumbnail Images */}
//         {productImages.length > 1 && (
//           <div className="productdetail-productcrousel">
//             {productImages.map((image, index) => (
//               <img
//                 key={index}
//                 src={image}
//                 alt={`${product.product_name} view ${index + 1}`}
//                 onClick={() => handleImageClick(image, index)}
//                 className={mainImage === image ? "active" : ""}
//                 onError={(e) => {
//                   e.target.src = "/path/to/placeholder-image.jpg";
//                 }}
//               />
//             ))}
//           </div>
//         )}

//         {/* Product Info */}
//         <div>
//           <h1 className="product-code">{product.group_code}</h1>
//           <h2 className="product-type">{product.product_name}</h2>
//           <p className="product-description">
//             {product.description || product.hint}
//           </p>
//         </div>

//         {/* Price Tables with Selection */}
//         {product.price && product.price.length > 0 && (
//           <div className="price-list-section">
//             <h1 className="price-list-title">SIZE & PRICE LIST</h1>

//             {Object.entries(groupedPrices).map(([category, data]) => (
//               <div key={category} className="price-table-container">
//                 <h2 className="table-subtitle">{category}</h2>
//                 <table className="price-table">
//                   <thead>
//                     <tr>
//                       <th>Wood Type / Size</th>
//                       {data.sizes.map((size) => (
//                         <th key={size}>{size}</th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {Object.entries(data.woodTypes).map(
//                       ([woodType, prices]) => (
//                         <tr key={woodType}>
//                           <td>{woodType}</td>
//                           {data.sizes.map((size) => {
//                             const priceItem = prices[size];
//                             return (
//                               <td
//                                 key={size}
//                                 onClick={() =>
//                                   priceItem && handlePriceSelect(priceItem.id)
//                                 }
//                                 className={`price-cell ${selectedPrice === priceItem?.id ? "selected" : ""} ${!priceItem ? "disabled" : ""}`}
//                                 style={{
//                                   cursor: priceItem ? "pointer" : "default",
//                                 }}
//                               >
//                                 {priceItem ? (
//                                   <>
//                                     {formatCurrency(priceItem.price)}
//                                     <br />
//                                     <span className="gst-text">
//                                       (incl. GST{" "}
//                                       {formatCurrency(priceItem.price_incl_tax)}
//                                       )
//                                     </span>
//                                   </>
//                                 ) : (
//                                   "-"
//                                 )}
//                               </td>
//                             );
//                           })}
//                         </tr>
//                       ),
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             ))}

//             {/* Selected Price Summary */}
//             {selectedPriceDetails && (
//               <div className="selected-price-summary">
//                 <h3>Selected Option:</h3>
//                 <p>
//                   <strong>Category:</strong> {selectedPriceDetails.category}
//                   <br />
//                   <strong>Wood Type:</strong> {selectedPriceDetails.wood_type}
//                   <br />
//                   <strong>Size:</strong> {selectedPriceDetails.size}
//                   <br />
//                   <strong>Price:</strong>{" "}
//                   {formatCurrency(selectedPriceDetails.price_incl_tax)} (incl.
//                   GST)
//                 </p>
//               </div>
//             )}

//             {/* Quantity Selector and Add to Cart */}
//             <div className="cart-actions">
//               <div className="quantity-selector">
//                 <label htmlFor="quantity">Quantity:</label>
//                 <input
//                   type="number"
//                   id="quantity"
//                   min="1"
//                   value={quantity}
//                   onChange={handleQuantityChange}
//                   disabled={addingToCart}
//                 />
//               </div>

//               <button
//                 className="add-to-cart-btn"
//                 onClick={addToCart}
//                 disabled={addingToCart || !selectedPrice}
//               >
//                 {addingToCart ? "Adding..." : "Add to Cart"}
//               </button>
//             </div>

//             {/* Cart Message */}
//             {cartMessage.text && (
//               <div className={`cart-message ${cartMessage.type}`}>
//                 {cartMessage.text}
//               </div>
//             )}

//             {/* Login Prompt if not logged in */}
//             {!isLoggedIn && (
//               <div className="login-prompt">
//                 <p>
//                   Please <a href="/AuthForm">login</a> to add items to your cart
//                 </p>
//               </div>
//             )}

//             <div className="product-notes">
//               <p>※Bank and height are standard at D780×H770mm.</p>
//               <p>
//                 ※Height can be ordered between SH370～470mm (in 10mm
//                 increments).
//               </p>
//               <p>
//                 ※In addition to denim and desk work, we also offer various
//                 textures of various recommendations. Please check briefly.
//               </p>
//             </div>
//           </div>
//         )}

//         {/* Specifications */}
//         {visibleSpecifications.length > 0 && (
//           <div className="specifications-section">
//             {visibleSpecifications.map((spec, index) => {
//               const specImages = spec.specificationsimages?.slice(0, 3) || [];

//               return (
//                 <div key={spec.id || index} className="product-feature-section">
//                   <h2 className="feature-section-title">{spec.key}</h2>

//                   {specImages.length > 0 && (
//                     <div
//                       className={`spec-images-container spec-images-${specImages.length}`}
//                     >
//                       {specImages.map((img, imgIndex) => (
//                         <img
//                           key={img.id || imgIndex}
//                           src={img.image}
//                           alt={`${spec.key} ${imgIndex + 1}`}
//                           className="spec-image"
//                           onError={(e) => {
//                             e.target.src = "/path/to/placeholder-image.jpg";
//                           }}
//                         />
//                       ))}
//                     </div>
//                   )}

//                   {spec.title && (
//                     <p className="feature-section-description">{spec.title}</p>
//                   )}
//                   {spec.value && (
//                     <p className="feature-section-text">{spec.value}</p>
//                   )}
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default Productbydetail;
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./Ecommerce.css";

const Productbydetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [mainImage, setMainImage] = useState("");


  // Cart state
  const [selectedPrice, setSelectedPrice] = useState(null);

  const [quantity, setQuantity] = useState(1);
  const [addingToCart, setAddingToCart] = useState(false);
  const [cartMessage, setCartMessage] = useState({ type: "", text: "" });
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    setIsLoggedIn(!!token);

    const fetchProduct = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://vogelkoparchitects.com/api/ecom/products/${id}/`,
        );

        if (!response.ok) {
          throw new Error("Failed to fetch product");
        }

        const productData = await response.json();
        setProduct(productData);

        if (productData.main_image) {
          setMainImage(productData.main_image);
        }

        setLoading(false);
      } catch (err) {
        console.error("Error fetching product:", err);
        setError("Failed to load product. Please try again later.");
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  const makeAuthenticatedRequest = async (url, options = {}) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return {
        error: "not_logged_in",
        status: 401,
        message: "Please log in to add items to cart",
      };
    }

    const response = await fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 401) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("username");
      localStorage.removeItem("tokenExpiry");
      setIsLoggedIn(false);

      return {
        error: "session_expired",
        status: 401,
        message: "Your session has expired. Please login again.",
      };
    }

    return response;
  };



  const getProductImages = () => {
    if (!product || !product.image) return [];
    return product.image.map((img) => img.image);
  };

  const handleImageClick = (imageSrc, index) => {
    setMainImage(imageSrc);
  };

  const groupPricesByCategory = () => {
    if (!product || !product.price) return {};

    const grouped = {};

    product.price.forEach((priceItem) => {
      const category = priceItem.category;

      if (!grouped[category]) {
        grouped[category] = {
          sizes: new Set(),
          woodTypes: {},
        };
      }

      grouped[category].sizes.add(priceItem.size);

      if (!grouped[category].woodTypes[priceItem.wood_type]) {
        grouped[category].woodTypes[priceItem.wood_type] = {};
      }

      grouped[category].woodTypes[priceItem.wood_type][priceItem.size] = {
        id: priceItem.id,
        price: priceItem.price,
        price_incl_tax: priceItem.price_incl_tax,
        category: priceItem.category,
        wood_type: priceItem.wood_type,
        size: priceItem.size,
      };
    });

    Object.keys(grouped).forEach((category) => {
      grouped[category].sizes = Array.from(grouped[category].sizes).sort();
    });

    return grouped;
  };

  const getVisibleSpecifications = () => {
    if (!product || !product.specifications) return [];
    return product.specifications.filter((spec) => spec.is_visible === true);
  };

  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return "₹0";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Handle price selection - Shows tick inside box when selected
  const handlePriceSelect = (priceItem) => {
    if (!priceItem) return;
    
    if (selectedPrice === priceItem.id) {
      // Toggle off if already selected
      setSelectedPrice(null);
    } else {
      setSelectedPrice(priceItem.id);
    }
    setCartMessage({ type: "", text: "" });
  };

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value);
    if (value > 0 && value <= 99) {
      setQuantity(value);
    }
  };

  const addToCart = async () => {
    if (!selectedPrice) {
      setCartMessage({
        type: "error",
        text: "Please select a size and wood type combination",
      });
      return;
    }

    setAddingToCart(true);
    setCartMessage({ type: "", text: "" });

    try {
      const response = await makeAuthenticatedRequest(
        "https://vogelkoparchitects.com/api/ecom/cart/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            product_id: parseInt(id),
            quantity: quantity,
            price_id: selectedPrice,
          }),
        },
      );

      if (response.error) {
        if (response.error === "not_logged_in") {
          setCartMessage({
            type: "error",
            text: response.message,
          });

          Swal.fire({
            title: "Login Required",
            text: response.message,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Go to Login",
            cancelButtonText: "Cancel",
          }).then((result) => {
            if (result.isConfirmed) {
              navigate("/AuthForm");
            }
          });
        } else if (response.error === "session_expired") {
          setCartMessage({
            type: "error",
            text: response.message,
          });

          Swal.fire({
            title: "Session Expired",
            text: response.message,
            icon: "info",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Go to Login",
          }).then(() => {
            navigate("/AuthForm");
          });
        } else {
          throw new Error(response.message || "Failed to add to cart");
        }
        return;
      }

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to add to cart");
      }

      setCartMessage({
        type: "success",
        text: data.message || "Product added to cart successfully!",
      });

      Swal.fire({
        title: "Success!",
        text: data.message || "Product added to cart successfully!",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });

      setTimeout(() => {
        setCartMessage({ type: "", text: "" });
      }, 3000);
    } catch (err) {
      console.error("Error adding to cart:", err);
      setCartMessage({
        type: "error",
        text: err.message || "Failed to add to cart. Please try again.",
      });

      Swal.fire({
        title: "Error!",
        text: err.message || "Failed to add to cart. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setAddingToCart(false);
    }
  };

  const getSelectedPriceDetails = () => {
    if (!selectedPrice || !product || !product.price) return null;
    return product.price.find((p) => p.id === selectedPrice);
  };

  const handleLoginRedirect = () => {
    navigate("/AuthForm");
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading product details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <p>{error}</p>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="empty-state">
        <h2>Product not found</h2>
        <p>The requested product could not be found.</p>
      </div>
    );
  }

  const productImages = getProductImages();
  const groupedPrices = groupPricesByCategory();
  const visibleSpecifications = getVisibleSpecifications();
  const selectedPriceDetails = getSelectedPriceDetails();

  return (
    <>
      <div className="product-detail-banner">
        <img
          src={mainImage || product.main_image}
          alt="Product banner"
          className="product-detail-banner-image"
          onError={(e) => {
            e.target.src = "/path/to/placeholder-image.jpg";
          }}
        />
        <h1 className="product-detail-title">{product.product_name || "Product Detail"}</h1>
      </div>

      <div className="product-detail-container">
        <div className="detailproduct-header">
          <div className="product-image-wrapper">
            <img
              src={mainImage || product.main_image}
              alt={product.product_name}
              onError={(e) => {
                e.target.src = "/path/to/placeholder-image.jpg";
              }}
            />
            {product.group_code && (
              <div className="product-group-code-overlay">
                {product.group_code}
              </div>
            )}
          </div>
        </div>

        {productImages.length > 1 && (
          <div className="productdetail-productcrousel">
            {productImages.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`${product.product_name} view ${index + 1}`}
                onClick={() => handleImageClick(image, index)}
                className={mainImage === image ? "active" : ""}
                onError={(e) => {
                  e.target.src = "/path/to/placeholder-image.jpg";
                }}
              />
            ))}
          </div>
        )}

        <div>
          <h2 className="product-type">{product.product_name}</h2>
          <p className="product-description">
            {product.description || product.hint}
          </p>
        </div>

        {product.price && product.price.length > 0 && (
          <div className="price-list-section">
            <h1 className="price-list-title">SIZE & PRICE LIST</h1>
            <div className="selection-instruction">
              👆 Click on any price box to select
            </div>

            {Object.entries(groupedPrices).map(([category, data]) => (
              <div key={category} className="price-table-container">
                <h2 className="table-subtitle">{category}</h2>
                <div className="table-responsive">
                  <table className="price-table">
                    <thead>
                      <tr>
                        <th>Wood Type / Size</th>
                        {data.sizes.map((size) => (
                          <th key={size}>{size}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(data.woodTypes).map(
                        ([woodType, prices]) => (
                          <tr key={woodType}>
                            <td className="wood-type-cell">{woodType}</td>
                            {data.sizes.map((size) => {
                              const priceItem = prices[size];
                              const isSelected = selectedPrice === priceItem?.id;
                              return (
                                <td
                                  key={size}
                                  data-price-id={priceItem?.id}
                                  onClick={() =>
                                    priceItem && handlePriceSelect(priceItem)
                                  }
                                  className={`price-cell ${isSelected ? "selected" : ""} ${!priceItem ? "disabled" : ""}`}
                                  style={{
                                    cursor: priceItem ? "pointer" : "default",
                                  }}
                                >
                                  {priceItem ? (
                                    <div className="price-cell-content">
                                      <div className="price-amount">
                                        {formatCurrency(priceItem.price)}
                                      </div>
                                      <div className="gst-text">
                                        incl. GST {formatCurrency(priceItem.price_incl_tax)}
                                      </div>
                                      {/* Empty box always shown, tick appears when selected */}
                                      <div className={`check-box ${isSelected ? "checked" : ""}`}>
                                        {isSelected && <span className="check-tick">✓</span>}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="no-price">-</div>
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}

            {selectedPriceDetails && (
              <div className="selected-price-summary">
                <div className="summary-tick">✓</div>
                <div className="summary-content">
                  <h3>Selected Option</h3>
                  <div className="summary-details">
                    <span className="summary-label">Category:</span>
                    <span className="summary-value">{selectedPriceDetails.category}</span>
                  </div>
                  <div className="summary-details">
                    <span className="summary-label">Wood Type:</span>
                    <span className="summary-value">{selectedPriceDetails.wood_type}</span>
                  </div>
                  <div className="summary-details">
                    <span className="summary-label">Size:</span>
                    <span className="summary-value">{selectedPriceDetails.size}</span>
                  </div>
                  <div className="summary-details">
                    <span className="summary-label">Price:</span>
                    <span className="summary-value price-highlight">
                      {formatCurrency(selectedPriceDetails.price_incl_tax)} (incl. GST)
                    </span>
                  </div>
                </div>
              </div>
            )}

            <div className="cart-actions">
              <div className="quantity-selector">
                <label htmlFor="quantity">Quantity:</label>
                <input
                  type="number"
                  id="quantity"
                  min="1"
                  max="99"
                  value={selectedPrice ? quantity : ""}
                  onChange={handleQuantityChange}
                  disabled={addingToCart || !selectedPrice}
                />
              </div>

              <button
                className="add-to-cart-btn"
                onClick={addToCart}
                disabled={addingToCart || !selectedPrice}
              >
                {addingToCart ? "Adding..." : "Add to Cart"}
              </button>
            </div>

            {cartMessage.text && (
              <div className={`cart-message ${cartMessage.type}`}>
                {cartMessage.text}
              </div>
            )}

            {!isLoggedIn && (
              <div className="login-prompt">
                <p>
                  Please{" "}
                  <button onClick={handleLoginRedirect} className="login-link-btn">
                    login
                  </button>{" "}
                  to add items to your cart
                </p>
              </div>
            )}
            
            <div className="product-notes">
              <p>※Bank and height are standard at D780×H770mm.</p>
              <p>※Height can be ordered between SH370～470mm (in 10mm increments).</p>
              <p>※In addition to denim and desk work, we also offer various textures of various recommendations. Please check briefly.</p>
            </div>
          </div>
        )}

        {visibleSpecifications.length > 0 && (
          <div className="specifications-section">
            {visibleSpecifications.map((spec, index) => {
              const specImages = spec.specificationsimages?.slice(0, 3) || [];

              return (
                <div key={spec.id || index} className="product-feature-section">
                  <h2 className="feature-section-title">{spec.key}</h2>

                  {specImages.length > 0 && (
                    <div className={`spec-images-container spec-images-${specImages.length}`}>
                      {specImages.map((img, imgIndex) => (
                        <img
                          key={img.id || imgIndex}
                          src={img.image}
                          alt={`${spec.key} ${imgIndex + 1}`}
                          className="spec-image"
                          onError={(e) => {
                            e.target.src = "/path/to/placeholder-image.jpg";
                          }}
                        />
                      ))}
                    </div>
                  )}

                  {spec.title && <p className="feature-section-description">{spec.title}</p>}
                  {spec.value && <p className="feature-section-text">{spec.value}</p>}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default Productbydetail;